import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'did_facility_experience_exceptional_circumstances_i_e_large'

export const dataPointDefinition = {
  retracedId: 'did_facility_experience_exceptional_circumstances_i_e_large',
  name: 'Did the facility experience exceptional circumstances (i.e. large late customer change orders, weather disasters etc.) t',
  description:
    'The intent of this question is to understand if the facility experienced circumstances, which substantially disrupt production and are out of the ordinary/out of the control of the facility. ',
  meta: {
    slcpMeta: {
      key: 'fl-8',
      number: 'WH-OVE-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fl-8', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27200,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
